export default __webpack_public_path__ + "static/media/image-3-m.6ee35a42.webp";